export class AuditHistoryDialog {

    private baseUrl: string;
    private dataTable: any;

    constructor(baseUrl: string = '/secure/ctms/audit/audit-history') {
        this.baseUrl = baseUrl;

        $(() => {
            this.dataTable = $('#audit-history-table').DataTable({
                dom: 'rtip',
                autoWidth: false,
                paging: false,
                info: false,
                scrollX: true,
                scrollY: '50vh',
                scrollCollapse: true,
                order: [[0, 'desc']],
                columns: [
                    { data: 'Timestamp', title: 'Timestamp', width: '160px' },
                    { data: 'OldValue', title: 'Old Value', defaultContent: '' },
                    { data: 'NewValue', title: 'New Value', defaultContent: '' },
                    { data: 'ModifiedByName', title: 'Modified By', width: '180px' }
                ]
            });

            $('#auditHistoryDialog').on('shown.bs.modal', () => {
                if (this.dataTable) this.dataTable.columns.adjust();
            });

            $('#audit-history-search').on('input', (e) => {
                this.dataTable.search(String($(e.target).val() ?? '')).draw();
            });

            $('#audit-history-search-clear').on('click', () => {
                $('#audit-history-search').val('');
                this.dataTable.search('').draw();
            });

            $('#auditHistoryDialog').on('hidden.bs.modal', () => {
                $('#audit-history-search').val('');
                this.dataTable.search('').clear().draw();
            });
        });
    }

    async show(entityType: string, entityId: number, fieldName: string, fieldLabel: string): Promise<void> {
        const url = `${this.baseUrl}?handler=FieldHistory&entityType=${encodeURIComponent(entityType)}&entityId=${entityId}&fieldName=${encodeURIComponent(fieldName)}`;

        try {
            const response = await fetch(url, { method: 'GET' });
            if (!response.ok) throw new Error(response.statusText);

            const data = await response.json();

            this.dataTable.clear();
            this.dataTable.rows.add(data).draw();

            document.querySelector('#auditHistoryDialogTitle').textContent = `${fieldLabel} — Audit History`;

            ($('#auditHistoryDialog') as any).modal('show');
        } catch (err) {
            console.error('Failed to load audit history', err);
        }
    }
}
